import { IQuality } from 'types/qualities';

export default function createCategories(possessions: { name: string, categories: string[], possessions: IQuality[]}[]) {
  return possessions.map(category => ({
    categories: category.categories,
    name: category.name,
    qualities: category.possessions.map(({ id }) => id),
  }));
}